<ngx-spinner [bdColor]="spinnerProp.bdColor" name="forgot" [fullScreen]="spinnerProp.fullScreen"
    [size]="spinnerProp.size" [color]="spinnerProp.color" [type]="spinnerProp.type">
</ngx-spinner>
<div class="text-center">
    <img src="assets/img/StaffingGo.png" alt="Password" width="80%" class="img-responsive big-logo"
        *ngIf="isShowImgLogo === false">
    <img [src]="getImgLogo | safe:'resourceUrl'" alt="Password" width="80%" class="img-responsive big-logo"
        *ngIf="isShowImgLogo === true">
</div>
<div class="fz-18 text-center my-3"><b>Did you forgot password?</b></div>
<div class="fz-18 text-center my-3"><b>Please enter your registered Email or mobile number</b></div>
<div class="alert alert-danger text-center p-2 m-1" role="alert" *ngIf="errMsg">
    <div>{{errMsg}}</div>
</div>

<form (submit)="fnForgotPassword(forgotPasswordModel)">
    <dx-form id="form" [formData]="forgotPasswordModel" [colCount]="2" labelLocation="top"
        [showColonAfterLabel]="false">
        <dxi-item [label]="{visible:false}" dataField="consEmailID" editorType="dxTextBox" [colSpan]="2"
            [editorOptions]="{ placeholder:'Enter Email or Mobile Number',inputAttr: {'style': 'text-transform: lowercase'}}">
            <dxi-validation-rule type="required"
                message="Enter Email or mobile number is required"></dxi-validation-rule>
            <dxi-validation-rule type="pattern" [pattern]="commonPatter"
                message="Please enter valid Email or phone number">
            </dxi-validation-rule>
        </dxi-item>
        <dxi-item itemType="button" horizontalAlignment="center" [colSpan]="2" [buttonOptions]="essForgotPassword">
        </dxi-item>
    </dx-form>
</form>
<p class="mb-2 mt-2 text-center btnLoginWPassword">
    <a href="javascript:void(0)" (click)="fnAlreadyPassword()">Already have login and password? Log in</a>
</p>